const getters = {
    versionChecked: state => state.versionChecked,
    appOutOfDate: state => state.appOutOfDate
};

export default getters;